import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"fill-height":"","fluid":"","grid-list-xl":""}},[_c(VFlex,[_c('app-upsert',{attrs:{"title":"Utilities","config":_vm.config}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }